<!-- 
共通ヘッダの画面部品
@props
  showAccountInfo : アカウント情報を表示するのならtrueを指定する
-->

<template>
  <v-row align="center">
    <v-col cols="1" sm="1" md="3" lg="4" xl="4"></v-col>
    <v-col cols="7" sm="7" md="5" lg="4" xl="4">
      <div class="text-center mb-8 mt-8">
        <span :class="titleClass">広島県水産プラットフォーム</span>
      </div>
    </v-col>
    <v-col cols="4">
      <div style="text-align: right" class="pr-8" v-if="showAccountInfo">
        <v-menu bottom style="z-index: 500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="text-none"
              >{{ loginUserName }}<v-icon>mdi-chevron-down</v-icon></v-btn
            >
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
              @click="item.event"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ValueMapper from "../../logic/common/value-mapper";
import Account from "@/logic/api/account.js";
export default {
  props: ["showAccountInfo"],
  computed: {
    titleClass() {
      return ValueMapper.map({
        xs: "text-h6",
        sm: "text-h6",
        md: "text-h5",
        lg: "text-h5",
      }).getOrElse(this.$vuetify.breakpoint.name, "text-h4");
    },
    loginUserName() {
      return this.$store.getters.userDisplayName;
    },
  },
  data() {
    // CSV出力権限フラグ取得
    this.dispFlag = this.$store.getters.csvPermission;
    // 広島県所属フラグ取得
    var isRootGroup = this.$store.getters.userGroupIds.includes('root');
    // メニューボタン表示フラグ
    if (isRootGroup && this.dispFlag) {
      return {
        items: [
          { title: "アカウント管理", event: this.onClickAccountManagement },
          { title: "グループ管理", event: this.onClickGroupManagement },
          { title: "利用状況", event: this.onClickUsageSituationt },
          { title: "個人別出荷量一覧", event: this.onClickShipmentQuantities },
          { title: "生産記録CSV一括出力", event: this.onClickProductOutputCsv },
          { title: "うみログCSV出力", event: this.onClickUmilogManagement },
          { title: "うみログ修正CSV入力", event: this.onClickInputUmilogManagement },
          { title: "レポート出力", event: this.onClickOutputReport },
          { title: "アンケート一覧", event: this.onClickQuestions },
          { title: "予測ツール操作情報出力", event: this.onClickOutpuOperationLogg },
          { title: "ログアウト", event: this.onClickLogout },
        ],
      };
    } else if (isRootGroup) {
      return {
        items: [
          { title: "アカウント管理", event: this.onClickAccountManagement },
          { title: "グループ管理", event: this.onClickGroupManagement },
          { title: "利用状況", event: this.onClickUsageSituationt },
          { title: "個人別出荷量一覧", event: this.onClickShipmentQuantities },
          { title: "レポート出力", event: this.onClickOutputReport },
          { title: "アンケート一覧", event: this.onClickQuestions },
          { title: "ログアウト", event: this.onClickLogout },
        ],
      };
    } else if (this.dispFlag) {
      return {
        items: [
          { title: "アカウント管理", event: this.onClickAccountManagement },
          { title: "グループ管理", event: this.onClickGroupManagement },
          { title: "生産記録CSV一括出力", event: this.onClickProductOutputCsv },
          { title: "うみログCSV出力", event: this.onClickUmilogManagement },
          { title: "ログアウト", event: this.onClickLogout },
        ],
      };
    } else {
      return {
        items: [
          { title: "アカウント管理", event: this.onClickAccountManagement },
          { title: "グループ管理", event: this.onClickGroupManagement },
          { title: "ログアウト", event: this.onClickLogout },
        ],
      };
    }
  },
  methods: {
    /**
     * アカウント管理ボタンをクリックした
     */
    onClickAccountManagement() {
      this.$router.push("/account", () => {});
    },
    /**
     * グループ管理ボタンをクリックした
     */
    onClickGroupManagement() {
      this.$router.push("/group", () => {});
    },
    /**
     * 利用状況ボタンをクリックした
     */
    onClickUsageSituationt() {
      this.$router.push("/usage", () => {});
    },
    /**
     * 個人別出荷量一覧ボタンをクリックした
     */
    onClickShipmentQuantities() {
      this.$router.push("/shipmentList", () => {});
    },
    /**
     * 生産記録CSV一括出力ボタンをクリックした
     */
    onClickProductOutputCsv() {
      this.$router.push("/allOutputCsv", () => {});
    },
    /**
     * うみログCSV出力ボタンをクリックした
     */
    onClickUmilogManagement() {
      this.$router.push("/umilog", () => {});
    },
    /**
     * うみログ修正CSV入力ボタンをクリックした
     */
    onClickInputUmilogManagement() {
      this.$router.push("/inputUmilog", () => {});
    },
    /**
     * レポート出力ボタンをクリックした
     */
     onClickOutputReport() {
      this.$router.push("/outputReport", () => {});
    },
    /**
     * アンケート一覧ボタンをクリックした
     */
     onClickQuestions() {
      this.$router.push("/question", () => {});
    },
    /**
     * 予測ツールの操作情報出力ボタンをクリックした
     */
    onClickOutpuOperationLogg(){
      this.$router.push("/operationLog", () => {});
    },
    /**
     * ログアウトボタンをクリックした
     */
    onClickLogout() {
      Account.signOut(this.$store, this.$router);
    },
  },
};
</script>

<style></style>
